import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useI18n } from "../i18n/I18nContext";

const STORAGE_KEY = "xeloriq_cookie_consent_v2";

function updateConsent(state) {
  if (typeof window === "undefined") return;
  window.dataLayer = window.dataLayer || [];
  function gtag() {
    window.dataLayer.push(arguments);
  }
  window.gtag = window.gtag || gtag;
  window.gtag("consent", "update", state);
}

export default function CookieBanner() {
  const { lang, t } = useI18n();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    try {
      const stored = localStorage.getItem(STORAGE_KEY);
      if (!stored) setVisible(true);
    } catch {
      setVisible(true);
    }
  }, []);

  const handleAcceptAll = () => {
    const state = {
      ad_storage: "granted",
      ad_user_data: "granted",
      ad_personalization: "granted",
      analytics_storage: "granted",
      functionality_storage: "granted",
      personalization_storage: "granted",
      security_storage: "granted",
    };
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify({ choice: "all", state, ts: Date.now() }));
    } catch {}
    updateConsent(state);
    setVisible(false);
  };

  const handleEssential = () => {
    const state = {
      ad_storage: "denied",
      ad_user_data: "denied",
      ad_personalization: "denied",
      analytics_storage: "denied",
      functionality_storage: "granted",
      personalization_storage: "denied",
      security_storage: "granted",
    };
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify({ choice: "essential", state, ts: Date.now() }));
    } catch {}
    updateConsent(state);
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      className="fixed inset-x-0 bottom-0 z-50 bg-[#071B34] text-white border-t-4 border-[#C85A32]"
      role="dialog"
      aria-labelledby="cookie-banner-title"
      data-testid="cookie-banner"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-5 grid grid-cols-1 md:grid-cols-3 gap-4 items-center">
        <div className="md:col-span-2">
          <div className="flex items-center gap-2 mb-1">
            <span
              id="cookie-banner-title"
              className="text-sm font-semibold uppercase tracking-wider"
            >
              {t("cookie_banner.title")}
            </span>
            <span className="text-[10px] font-mono bg-[#C85A32] text-white px-2 py-0.5">
              {t("cookie_banner.subtitle")}
            </span>
          </div>
          <p className="text-xs text-white/75 leading-relaxed">
            {t("cookie_banner.description")}{" "}
            <Link
              to={`/${lang}/cookies`}
              className="underline underline-offset-2 text-white"
              data-testid="cookie-banner-policy-link"
            >
              {t("cookie_banner.read_policy")}
            </Link>
          </p>
        </div>
        <div className="flex flex-col sm:flex-row gap-2 md:justify-end">
          <button
            type="button"
            onClick={handleEssential}
            data-testid="cookie-banner-decline-button"
            className="border border-white/40 text-white text-sm font-semibold px-4 py-2 hover:bg-white/10"
          >
            {t("cookie_banner.essential_only")}
          </button>
          <button
            type="button"
            onClick={handleAcceptAll}
            data-testid="cookie-banner-accept-button"
            className="bg-[#C85A32] hover:bg-[#B04B27] text-white text-sm font-semibold px-4 py-2"
          >
            {t("cookie_banner.accept_all")}
          </button>
        </div>
      </div>
    </div>
  );
}
